import FILTER_OPTIONS from '_constants/old/filters/FILTER_OPTIONS';
import { PROXIMITY_RANGE_LIST_OBJ } from 'mapcontrols/constants';

const {
  NEAR_SCHOOL_PROXIMITY_OPTIONS,
  NEAR_PARKS_PROXIMITY_OPTIONS,
  NEAR_RETAILER_PROXIMITY_OPTIONS,
  NEAR_PARKS_AND_SCHOOLS_PROXIMITY_OPTIONS,
  NEAR_PARKS_OR_SCHOOLS_PROXIMITY_OPTIONS,
} = FILTER_OPTIONS;

export const PROXIMITY_FILTER_OPTIONS_BY_PLACE = {
  near_school: NEAR_SCHOOL_PROXIMITY_OPTIONS,
  near_parks: NEAR_PARKS_PROXIMITY_OPTIONS,
  near_retailer: NEAR_RETAILER_PROXIMITY_OPTIONS,
  retailersnearparksschools: NEAR_PARKS_AND_SCHOOLS_PROXIMITY_OPTIONS,
  retailersnearparksschools_or: NEAR_PARKS_OR_SCHOOLS_PROXIMITY_OPTIONS,
};

const getPlaceKeyAndRange = ({ activeLayer, layerConfigs }) => {
  if (activeLayer === 'retailersnearretailers_az') {
    return { placeKey: 'near_retailer', range: layerConfigs?.near_retailer?.range };
  }
  if (activeLayer === 'retailersnearschools_az' || activeLayer === 'retailersnearparks_az') {
    return { placeKey: layerConfigs?.near_school?.place, range: layerConfigs?.near_school?.range };
  }
  return { placeKey: null, range: null };
};

export const resolveProximityFilterOption = (proximityState) => {
  if (!proximityState) return null;
  const { activeLayer } = proximityState;
  if (!activeLayer || activeLayer === 'no_proximity' || activeLayer === 'retailerpoints') return null;

  const { placeKey, range } = getPlaceKeyAndRange(proximityState);
  const options = PROXIMITY_FILTER_OPTIONS_BY_PLACE[placeKey];
  const wmsLayerName = PROXIMITY_RANGE_LIST_OBJ[placeKey]?.[range];
  if (!options || !wmsLayerName) return null;

  return options.find((o) => o.legacyField === wmsLayerName || o.field === wmsLayerName) || null;
};

export const resolveProximityFilter = (proximityState) => {
  const option = resolveProximityFilterOption(proximityState);

  if (!option) return null;
  return option.value ? `${option.field}=${option.value}` : `${option.field}=t`;
};
